import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AbstractAuthorizationService } from "src/app/authorization/services/abstractAuthorization.service";
import { selectIfCurrentUserIs } from "src/app/user/state";

@Component({
    selector: "circ-menu-shell",
    templateUrl: "./menu-shell.component.html",
    styleUrls: ["./menu-shell.component.scss"],
    standalone: false
})
export class MenuShellComponent implements OnInit {
  //Just for nav toggle
  public expanded = true;
  public drawerMode = "push";
  private cachedWidth = window.innerWidth;
  private mobileSize = 715;
  private desktopSize = 1200;

  @Input() public isAdmin$: Observable<boolean>;
  @Output() navClick = new EventEmitter<string>(); //NTH replace with store logic
  constructor(
    private store: Store,
    private authorizationService: AbstractAuthorizationService
  ) {
    this.isAdmin$ = this.store.select(
      selectIfCurrentUserIs((user) =>
        this.authorizationService.isAdmin(user.roles)
      )
    );
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event): void {
    const newWidth = (event.target as Window).innerWidth;
    if (newWidth !== this.cachedWidth) {
      this.expanded = !(newWidth < this.desktopSize);
      this.drawerMode = newWidth < this.mobileSize ? "overlay" : "push";
      this.cachedWidth = newWidth;
    }
  }

  public ngOnInit(): void {
    this.expanded = window.innerWidth >= this.desktopSize;
  }

  public navigationEventHandler($event: string): void {
    if (window.innerWidth < this.mobileSize) {
      this.expanded = false;
    }
    this.navClick.emit($event);
  }

  public toggle(): void {
    this.expanded = !this.expanded;
  }
}
